export const CREATE_LOAN_INTENT_ERROR_MESSAGES = {
  ORDER_NOT_FOUND: "Order not found. Please check the order and try again.",
  MISMATCHED_LOAN_EMI_DIVISION_DETAILS_VERTICAL_ID:
    "The selected tenure does not match the order's vertical. Please select a valid provider and tenure.",
  LOAN_EMI_DIVISION_DETAILS_NOT_FOUND:
    "Loan EMI division details not found. Please select the provider and tenure again.",
  INTENDED_LOAN_AMOUNT_OUT_OF_RANGE:
    "The entered loan amount is not in the allowed range for this provider. Please check minimum and maximum and try again.",
  DOWN_PAYMENT_AMOUNT_MISMATCH:
    "Down payment amount does not match. Please verify the amount and try again.",
  LOAN_AMOUNT_PLUS_CUSTOMER_PAID_AMOUNT_EXCEEDS_LISTED_ORDER_AMOUNT:
    "Loan amount plus amount already paid exceeds the order amount. Please enter a lower loan amount.",
  INVALID_EMI_DIVISION_DETAILS:
    "Invalid EMI division details. Please select the provider and tenure again.",
};

export const PUNCH_PAYMENT_V2_ERROR_MESSAGES = {
  ORDER_NOT_FOUND: "Order not found. Please check the order and try again.",
  PAYMENT_AMOUNT_LESS_THAN_FIRST_INSTALLMENT:
    "Payment amount is less than the first installment. Please collect the required amount.",
  PAYMENT_EXCEEDS_PENDING_LIMIT:
    "Payment amount exceeds the pending limit for this order.",
  ACTIVE_LOAN_ALREADY_EXISTS:
    "An active loan already exists for this order. You cannot punch another loan.",
  LOAN_ID_EXISTS_FOR_ANOTHER_ORDER:
    "This loan application number is already used for another order. Please use a different loan application number.",
  ACTIVE_INSTALLMENT_PLAN_HAS_NO_INSTALLMENTS:
    "The installment plan has no installments. Please contact support.",
  LOAN_AMOUNT_NOT_EQUAL_TO_REMAINING:
    "Loan amount does not match the remaining order amount. Please verify and try again.",
  LOAN_AMOUNT_NOT_EQUAL_TO_REMAINING_ORDER_AMOUNT:
    "Loan amount does not match the remaining order amount. Please verify and try again.",
  ONLY_RAZORPAY_FOR_SCA_VERTICAL:
    "Only Razorpay is allowed for this vertical. Please select Razorpay as the payment provider.",
  EMAIL_REQUIRED_FOR_PAYU:
    "Email is required for PayU payments. Please provide the customer email.",
  PAYMENT_AMOUNT_EXCEEDS_ALLOWABLE_LIMIT:
    "Payment amount exceeds the allowable limit.",
  PAYMENT_LINK_AMOUNT_MISSING:
    "Payment link amount is missing. Please create the payment link again.",
  ONLINE_PAYMENT_AMOUNT_NOT_EQUAL_TO_PAYMENT_LINK:
    "Online payment amount does not match the payment link amount.",
  DUPLICATE_CHEQUE_SAME_BANK_AND_NUMBER:
    "A cheque with the same bank and number already exists. Please use a different cheque.",
  INVALID_PROVIDER_V2:
    "Invalid payment provider. Please select a valid provider.",
  LOAN_EMI_DIVISION_DETAILS_NOT_FOUND:
    "Loan EMI division details not found. Please create loan intent again.",
  LOAN_INTENT_NOT_FOUND:
    "Loan intent not found. Please create the loan intent first and then punch the loan.",
  PAYMENT_AMOUNT_MISMATCH_INTENDED_LOAN_AMOUNT:
    "Payment amount does not match the intended loan amount. Please verify and try again.",
  AMOUNT_PLUS_DOWN_PAYMENT_MISMATCH:
    "Amount and down payment do not match. Please verify the amounts.",
  AMOUNT_PLUS_DOWN_PAYMENT_MISMATCH_INTENT_AMOUNT:
    "Amount plus down payment does not match the intended loan amount. Please verify and try again.",
  LOAN_NOT_ALLOWED_FOR_PART_PAYMENT:
    "Loan payments are not allowed for part payment (Installments) orders. Please use a different payment mode.",
  INVALID_PAYMENT_MODE:
    "Invalid payment mode. Please select a valid payment mode.",
};

export const getApiErrorMessage = (error, messageMap) => {
  const code = error?.error_code;
  if (code && messageMap[code]) {
    return messageMap[code];
  }
  return error?.message || "Something went wrong. Please try again.";
};
